import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { TokenManager } from "./api";
import { AuthProvider } from "./context/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';

async function startApp() {
  const rootElement = document.getElementById("root");
  if (!rootElement) return;

  const root = createRoot(rootElement as HTMLElement);

  try {
    // Initialize native storage for tokens
    await TokenManager.init();

    // Configure native UI elements if on a device
    if (Capacitor.isNativePlatform()) {
      try {
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.setBackgroundColor({ color: '#ffffff' });
        // Hide splash screen after initialization
        await SplashScreen.hide();
      } catch (e) {
        console.warn('Native UI plugins not available', e);
      }
    }

    root.render(
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    );
  } catch (error) {
    console.error("CRITICAL APP STARTUP ERROR:", error);
    // Fallback render to show something if initialization fails
    root.render(
      <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50 text-center">
        <div>
          <h1 className="text-xl font-bold text-red-600 mb-2">Startup Error</h1>
          <p className="text-gray-600 mb-4">The application failed to start.</p>
          <button 
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }
}

// Fire up the engine!
startApp();
